import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "../lib/api";
import { displayName } from "../lib/anagConfig";

const norm = (s) => (s || "").toLowerCase().replace(/[.,;:'"()\-_/]+/g, " ").trim().replace(/\s+/g, " ");
const sortTok = (s) => norm(s).split(" ").filter(Boolean).sort().join(" ");

const matches = (r, nome) => {
  const t = norm(nome), ts = sortTok(nome);
  const cands = [displayName(r), r.denominazione, r.ragione_sociale, r.abbreviazione,
    [r.nome, r.cognome].filter(Boolean).join(" "), [r.cognome, r.nome].filter(Boolean).join(" ")];
  if (cands.some((c) => c && norm(c) === t)) return true;
  return [r.denominazione, [r.nome, r.cognome].filter(Boolean).join(" ")].some((c) => c && sortTok(c) === ts);
};

const looseMatches = (r, nome) => {
  const toks = new Set(norm(nome).split(" ").filter(Boolean));
  if (toks.size < 2) return false;
  const cands = [displayName(r), r.denominazione, r.ragione_sociale, r.abbreviazione, [r.nome, r.cognome].filter(Boolean).join(" ")];
  return cands.some((c) => {
    const kt = norm(c).split(" ").filter(Boolean);
    return kt.length >= 2 && (kt.every((x) => toks.has(x)) || [...toks].every((x) => kt.includes(x)));
  });
};

const isConfigured = (r) => {
  const pct = Number((String(r.compenso_percentuale || "").match(/\d+(?:[.,]\d+)?/) || ["0"])[0].replace(",", "."));
  if ((r.compenso_tipo || "fisso") === "percentuale") return pct > 0 && !!r.compenso_base;
  return Number(String(r.compenso_importo || "").replace(",", ".")) > 0;
};

export const SegnalatoreAnagWarning = ({ nome }) => {
  const [state, setState] = useState(null);
  useEffect(() => {
    const n = (nome || "").trim();
    if (!n) { setState(null); return; }
    let alive = true;
    Promise.all([
      api.get("/anagrafiche/segnalatori").then((r) => r.data || []).catch(() => null),
      api.get("/anagrafiche/agenzie").then((r) => r.data || []).catch(() => []),
    ]).then(([s, ag]) => {
      if (!alive || s === null) return;
      const all = [...s, ...ag];
      let recs = all.filter((r) => matches(r, n));
      if (recs.length === 0) recs = all.filter((r) => looseMatches(r, n));
      if (recs.length === 0) setState("missing");
      else setState(recs.some(isConfigured) ? null : "unconfigured");
    });
    return () => { alive = false; };
  }, [nome]);

  if (!state) return null;
  return (
    <div className="mt-2 flex items-start gap-2 rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs text-amber-200" data-testid={`segnalatore-warning-${state}`}>
      <AlertTriangle className="h-4 w-4 shrink-0 text-amber-400" />
      {state === "missing"
        ? <span>Il segnalatore «{nome}» non corrisponde a nessuna scheda in Anagrafiche → Segnalatori: il compenso non potrà essere calcolato. Seleziona il segnalatore dall'elenco o crea la sua scheda.</span>
        : <span>La scheda del segnalatore «{nome}» non ha un compenso configurato: imposta tipo, percentuale e base di calcolo in Anagrafiche → Segnalatori.</span>}
    </div>
  );
};
